<template>
  <div class="root">
    <template v-if="discount&&Number(discount.discount)!==10">
      <b class="left">{{discount.discount}}折报名中</b>
    </template>
    <template v-else-if="discount&&Number(discount.discount)===10">
      <div class="wrapper">
        <h1 class="">报名倒计时{{discount.remainDays}}天</h1>
        <!-- <h2 class="">团购享更多优惠</h2> -->
      </div>
    </template>
    <template v-else>
      <div>
        <h1 v-if="data.title" v-html="data.title"></h1>
        <h2 v-if="isShowSubTitle" v-html="data.subtitle"></h2>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  props: ['data', 'price'],
  computed: {
    discount () {
      if (!this.data.showDiscount) return false
      for (let i = 0; i < this.price.discount.length; i++) {
        let d = this.price.discount[i]
        let cur = moment()
        let end = moment(new Date(d.end))
        if (!cur.isAfter(end)) {
          let remainDays = moment(end).diff(cur, 'days') + 1
          let discountPrice = (this.price.price - d.price) / 100
          let discount = d.discount
          return { remainDays, discountPrice, discount }
        }
      }
      return false
    },
    isShowSubTitle () {
      if (this.data.title) return false
      else return true
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
  .root
    padding: 6px 11px
    display: flex
    justify-content: center
    align-items: center
    background-color: var(--primary-color)
    color: #fff
    font-size: 14px
    border-radius: 4px
</style>
